import { SkeletonItem, SkeletonLine, SkeletonList } from './ReportsListSkeleton.styles';

const DEFAULT_ITEM_COUNT = 5;

type ReportsListSkeletonProps = {
  itemCount?: number;
};

export function ReportsListSkeleton({ itemCount = DEFAULT_ITEM_COUNT }: ReportsListSkeletonProps) {
  return (
    <SkeletonList>
      {Array.from({ length: itemCount }).map((_, index) => (
        <SkeletonItem key={`reports-skeleton-${index}`}>
          <SkeletonLine />
          <SkeletonLine $width="60%" />
          <SkeletonLine $width="40%" />
        </SkeletonItem>
      ))}
    </SkeletonList>
  );
}
